import React, { Component } from 'react';
import _ from 'lodash';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { Grid, Typography, Button, WithStyles, createStyles } from '@material-ui/core';

import NoContent from './NoContent';
import WithContent from './WithContent';
import ContentTopMenu from '../components/ContentTopMenu';
import CreateContentModals from '../components/CreateContentModals';

import ContentData from '../types/ContentData';
import { ContentListFilterData } from '../types/ContentFilterData';
import ACL from '../../acl/components/ACL';
//actions
import contentActions from '../actions/contentActions';

import courseService from '../services/courseService';
import HelpDetails from '../components/HelpDetails';
import contentSubtypeActions from '../actions/contentSubtypeActions';
import { toggleLicenseExpiredDialog } from "../../login/actions/userActions";
import { Redirect } from 'react-router-dom';
import { CONTENT_SECTION_KEYS, CONTENT_SECTION_TYPES, MODULE_TO_QUESTION_PERMISSION_MAP, MODULE_TO_TEST_PERMISSION_MAP, PERMISSION_CONTENT_TYPES, USER_RIGHTS } from '../../../constants/comman';
import ACLService from '../../acl/services/aclService';

const styles = (theme: Theme) => createStyles({
	ulDefault: {
		padding: 0,
		margin: 0,
	},
	createContentButton: {
		marginRight: theme.spacing.unit * 4,
	},
	listItem: {
		display: 'inline-block',
		padding: theme.spacing.unit,
		paddingTop: 0,
		paddingBottom: 0,
		'&:first-child': {
			paddingLeft: 0,
		},
	},
	linkItem: {
		...theme.typography.body1,
		textDecoration: 'none',
		'&.active, &:active, &:focus, &:hover': {
			color: theme.palette.primary.main,
			textDecoration: 'underline',
		}
	}
});

//@ts-ignore
interface MyLibraryHomeProps extends WithStyles<typeof styles> {
	classes: any,
	contentList: ContentData[],
	contentActionList: Function,
	isFirstLoad: boolean,
	contentSubtype: any,
	contentSubtypeList: Function,
	toggleLicenseExpiredDialog: any,
	history: any,
}

interface MyLibraryHomeStates {
	hasContent: Boolean,
	createContentOpen: Boolean,
	filterContent: ContentListFilterData,
	goals: any,
	tabsShown: any;
}

class MyLibraryHome extends Component<MyLibraryHomeProps, MyLibraryHomeStates> {
	constructor(props: MyLibraryHomeProps) {
		super(props);
		const tabsShown = CONTENT_SECTION_TYPES.filter(tab => {
			let hasAccessToStudyMaterial: boolean = false;
			if(tab.value === CONTENT_SECTION_KEYS.GLORIFIRE) {
				hasAccessToStudyMaterial = [USER_RIGHTS.VIEW, USER_RIGHTS.CREATE, USER_RIGHTS.EDIT].some(right => ACLService.checkModulePermission(PERMISSION_CONTENT_TYPES.STUDY_MATERIAL, right));
			}
			return hasAccessToStudyMaterial || [USER_RIGHTS.VIEW, USER_RIGHTS.CREATE, USER_RIGHTS.EDIT].some(right => {
				return (ACLService.checkModulePermission(MODULE_TO_QUESTION_PERMISSION_MAP[tab.value], right) || ACLService.checkModulePermission(MODULE_TO_TEST_PERMISSION_MAP[tab.value], right));
			});
		});
		props = {
			...props,
			contentList: [],
			isFirstLoad: true,
		}

		this.state = {
			hasContent: true,
			createContentOpen: false,
			filterContent: {
				contentMenu: "all",
			},
			goals: [],
			tabsShown: tabsShown,
		};

		this.createContentOpenHandler = this.createContentOpenHandler.bind(this);
		this.createContentCloseHandler = this.createContentCloseHandler.bind(this);
	}


	componentDidMount() {
		if (localStorage.getItem('isFirstUser') === 'true') {
			this.props.history.push('/set-password')
		} else {
			const {tabsShown} = this.state;
			let filtersData: any = localStorage.getItem('filtersData')
			let filtersDataCopy = JSON.parse(filtersData) 
			filtersDataCopy = filtersDataCopy ? filtersDataCopy : {}
			let {filterContent} = this.state
			filterContent = filterContent ? filterContent : {}
			filterContent.contentFilterData = filtersDataCopy.contentFilterData
			if (tabsShown.length) {
				filterContent.bucketType = tabsShown[0].value;
			}
			if (_.get(this.props, 'contentSubtype.list.length', 0) === 0) {
				this.props.contentSubtypeList();
			}
			//All goals
			// this.props.toggleLicenseExpiredDialog(false);
		}
	}
	
	componentWillUnmount() {
		localStorage.removeItem('filtersData')
	}

	componentDidUpdate() {
	}


	createContentOpenHandler = (event: any) => {
		this.setState({
			createContentOpen: true
		});
	};

	createContentCloseHandler = (event: any) => {
		this.setState({
			createContentOpen: false
		});
	};

	render() {
		const { classes, contentList, isFirstLoad } = this.props;
		const { hasContent, createContentOpen, goals, tabsShown } = this.state;
		const Content = tabsShown.length ?
			<WithContent filterHeaderClassName={classes.stickyHeadFilter} goals={goals} />
			: <NoContent />;

		return (
			<>
				<Grid container
					spacing={0}
					direction="column"
					className={classes.root}>
					<Grid item xs={12}>
						{Content}
					</Grid>
				</Grid>
			</>
		)
	}
}

const mapStateToProps = (state: any) => ({
	contentList: _.get(state, 'mylibraryData.content.list', []),
	isFirstLoad: _.get(state, 'mylibraryData.content.isFirstLoad', true),
	contentSubtype: _.get(state, 'mylibraryData.contentSubtype', {}),
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators(
	{
		contentActionList: contentActions.list,
		contentSubtypeList: contentSubtypeActions.list,
		toggleLicenseExpiredDialog
	},
	dispatch
);

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MyLibraryHome));